import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initErrorHandling } from './services/errorService';

// Initialize global error handlers at the very start
initErrorHandling();

// --- Mobile Viewport Height Fix ---
// This ensures the app's height is correctly calculated on mobile devices,
// especially iOS Safari, where the browser UI can change the viewport size.
const setAppHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty('--app-height', `${window.innerHeight}px`);
};
window.addEventListener('resize', setAppHeight);
setAppHeight();
// --- End Fix ---

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('ServiceWorker registration successful with scope: ', registration.scope);
      })
      .catch(err => {
        console.log('ServiceWorker registration failed: ', err);
      });
  });
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);